import React from 'react';
import { connect } from 'react-redux';
import { withRouter , Link} from 'react-router';
import * as PatientsActions from '../../../actions/admin/patients_actions';
import * as FacilitiesActions from '../../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import { validate } from '../../../validations';
import Header from '../../../components/header';
let screenIdentifier = 'addPatients';
import InputMask from 'react-input-mask';
import _ from 'lodash';
import { cutom_utils } from '../../../ucd_utils/util';
import * as UserActions from '../../../actions/user_actions';

export var AddPatients = React.createClass({
    getInitialState() {
        return {
            //staff_data: null,
            isFormSubmitted: null,
            errorMessage: null,
            okModalMessage: null,
            isCreateUserSucceed: null,
            mobileCssClass: "inputText",
            PsychiatristList: [],
            TheraoistList: [],
        }
    },
    componentWillMount() {

        var facility_id = this.props.UserDetails.selectdUserFacilityID;
        this.props.Dispatch(UserActions.getTherapistList(facility_id));
        this.props.Dispatch(UserActions.getPsychiatristList(facility_id));

    },
    componentWillReceiveProps(nextProps) {

        nextProps.UserDetails.PsychiatristList && nextProps.UserDetails.PsychiatristList.status == 200 && this.setState({ PsychiatristList: nextProps.UserDetails.PsychiatristList.data });
        nextProps.UserDetails.TheraoistList && nextProps.UserDetails.TheraoistList.status == 200 && this.setState({ TheraoistList: nextProps.UserDetails.TheraoistList.data });
        // need to Remove
        //nextProps.PatientsDetails.AllStaffData && nextProps.PatientsDetails.AllStaffData.status == 200 && this.setState({ staff_data: nextProps.PatientsDetails.AllStaffData.data });

        if (this.state.isFormSubmitted && nextProps.FacilitiesDetails.FaciliteAdmin) {
            this.setState({ isFormSubmitted: null });
            nextProps.FacilitiesDetails.FaciliteAdmin.status == 200 ? this.setState({ isCreateUserSucceed: true, okModalMessage: nextProps.FacilitiesDetails.FaciliteAdmin.message }) : this.setState({ isCreateUserSucceed: null, okModalMessage: nextProps.FacilitiesDetails.FaciliteAdmin.message });
            nextProps.FacilitiesDetails.FaciliteAdmin = null;
        }
    },
    email_validate(event) {
        let email = event.target.value;
        let isValidEmail = validate.email(email);
        isValidEmail ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    phone_Validate(event) {
        validate.phone(event.target.value) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    no_empty(event) {
        event.target.value.trim().length > 0 ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },
    addFacility() {

    },

    closebox() {
        this.setState({ okModalMessage: null });
        if (this.state.isCreateUserSucceed) {
            this.setState({ isCreateUserSucceed: null });
            this.props.router.push('/patients#new');
            let facilitiesID = this.props.UserDetails.selectdUserFacilityID;
            this.props.Dispatch(PatientsActions.getAllPaientsData(facilitiesID));
        }
    },
    remove_error(event) {
        event.target.type === "text" ? event.target.className = 'inputText' : event.target.className = '';
    },
    add_facility_admin() {

        //var facility_id =  window.location.search ? validate.getUrlParam('id') : window.location.hash === "#new" ?this.props.FacilitiesDetails.FaciliteCreateDeatils.data.id:this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;

        var facility_id = this.props.UserDetails.selectdUserFacilityID;
        let firstName = this.refs.firstName.value.trim(),
            lastName = this.refs.lastName.value.trim(),
            mobile = this.refs.mobile.state.value.replace(/ /g, ""),
            email = this.refs.email.value.trim(),
            dobYear = this.refs.dobYear.value.trim(),
            psychiatrist = this.refs.psychiatrist.value.trim(),
            therapist = this.refs.therapist.value.trim();

        let isValidEmail = validate.email(email);
        let isValidMobile = validate.phone(mobile);

        !firstName.length ? this.refs.firstName.className = "inputText error" : this.refs.firstName.className = "inputText";
        !lastName.length ? this.refs.lastName.className = "inputText error" : this.refs.lastName.className = "inputText";
        !dobYear.length ? this.refs.dobYear.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom' : this.refs.dobYear.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
        //  !psychiatrist.length ? this.refs.psychiatrist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom' : this.refs.psychiatrist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
        //  !therapist.length ? this.refs.therapist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom' : this.refs.therapist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
        if (psychiatrist.length || therapist.length) {
            this.refs.psychiatrist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
            this.refs.therapist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
        }
        else {
            this.refs.psychiatrist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom';
            this.refs.therapist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom';
        }

        !isValidEmail ? this.refs.email.className = "inputText error" : this.refs.email.className = "inputText";
        !isValidMobile ? this.setState({ mobileCssClass: 'inputText error' }) : this.setState({ mobileCssClass: 'inputText' });

        if ((psychiatrist.length === 0 && therapist.length === 0) || firstName.length === 0 || lastName.length === 0 || mobile.length === 0 || email.length === 0 || dobYear.length === 0) {
            this.setState({ errorMessage: "Please enter necessary fields to proceed." });
            return false;
        }

        if ((psychiatrist.length || therapist.length) && dobYear.length && firstName.length && lastName.length && mobile.length && isValidEmail && isValidMobile) {
            this.setState({ errorMessage: null });
            var data = {
                "firstName": firstName,
                "lastName": lastName,
                "mobile": mobile,
                "email": email,
                "yearOfDob": dobYear,
                "createdBy": { "id": this.props.UserDetails.loginData.data.id, role: { "id": this.props.UserDetails.selectedUserRoleID } },
                "facility": { "id": facility_id },
                "role": { "id": 7 }, // Type of user hard coded for patients

            }
            if (psychiatrist.length) {
                data.psychiatrist = { "id": psychiatrist }
            }
            if (therapist.length) {
                data.therapist = { "id": therapist }
            }

            this.setState({ isFormSubmitted: true });
            this.props.Dispatch(FacilitiesActions.createFaclityAdmin(data));
        }
        else {

            this.setState({ errorMessage: "Please enter valid information to proceed." });


            // Start - To handle no active Psychiatrists or therapists available to this facility.
            // var staffs = this.state.staff_data;
            // var Psychiatrists = _.filter(staffs, function (item) {
            //     return item.roleId == 3 && item.status === "APPROVE";
            // });

            if (this.state.PsychiatristList && this.state.PsychiatristList.length < 0 && this.state.TheraoistList && this.state.TheraoistList.length < 0) {
                this.setState({ okModalMessage: "Add at least one psychiatrist or therapist to this clinic to proceed." });
                return;
            }

            // var therapists = _.filter(staffs, function (item) {
            //     return item.roleId == 4 && item.status === "APPROVE";;
            // });

            // if (this.state.TheraoistList && this.state.TheraoistList.length < 0) {
            //     this.setState({ okModalMessage: "Add at least one therapist to this clinic to proceed." });
            //     return;
            // }
            // End - To handle no active Psychiatrists or therapists available to this facility.
        }


    },
    cancel() {
        this.props.router.goBack();
    },

    selectionChanged(event) {
        event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom';
    },
    cancel() { this.props.router.goBack(); },
    render() {

        //var staffs = this.state.staff_data;
        var Psychiatrist = this.state.PsychiatristList ? this.state.PsychiatristList : [];
        var psychiatristOptions = Psychiatrist.map(function (list, key) {
            return (<option value={list.id} key={key}>{list.firstName + " " + list.lastName}</option>)
        }, this);

        var Therapist = this.state.TheraoistList
        var therapistOptions = Therapist.map(function (list, key) {
            return (<option value={list.id} key={key}>{list.firstName + " " + list.lastName}</option>)
        }, this);

        var getYrs = cutom_utils.getYears();
        var yearOptions = getYrs.map(function (years) {
            return <option key={years}
                value={years}>{years}</option>;
        });
        ;
        return (
            <div className="dashboard-inner-content">
                <Header screenIdentifier={screenIdentifier} breadcrumb={true}/>
                <div className="breadcrumb-custom">
                  <h2> <Link to="/patients">PATIENTS</Link> > ADD PATIENTS</h2>
                </div>
                <div className="white-box">
                    <div className="recovery-facility">
                        <h4>ADD PATIENT </h4>
                        <div className="row">
                            <div className="col-xs-8 no-padding staff-recovery">
                                <div className="row">
                                    <div className="col-xs-6 padding-right-20">
                                        <div className="input-group">
                                            <input type="text" className="inputText" onFocus={this.remove_error} ref="firstName" onBlur={this.no_empty} maxLength="64" required />
                                            <span className="floating-label">First Name</span>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 no-padding">
                                        <div className="input-group">
                                            <input type="text" className="inputText" onFocus={this.remove_error} ref="lastName" onBlur={this.no_empty} maxLength="64" required />
                                            <span className="floating-label">Last Name</span>
                                        </div>
                                    </div>
                                </div>


                                <div className="row">

                                    <div className="col-xs-12 no-padding">
                                        <div className="input-group">
                                            <input type="text" className="inputText" onFocus={this.remove_error} onBlur={this.email_validate} ref="email" required />
                                            <span className="floating-label">Email</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6 padding-right-20">
                                        <div className="input-group">
                                            <InputMask type="text" className={this.state.mobileCssClass} onFocus={this.remove_error} onBlur={this.phone_Validate} ref="mobile" required mask="999 999 9999" maskChar={null} />
                                            <span className="floating-label">Phone</span>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 no-padding ">
                                        <div className="aj-dropdown with-label">
                                            <label>Year of Birth</label>
                                            <div className="source">
                                                <div className="question-selection">
                                                    <select ref="dobYear" onChange={this.selectionChanged} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                                        <option value="" default>Year</option>
                                                        {yearOptions}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xs-6 no-padding padding-right-20">
                                            <div className="aj-dropdown with-label">  <label>Assign Psychiatrist</label>
                                                <div className="source">
                                                    <div className="question-selection">
                                                        <select ref="psychiatrist" onChange={this.selectionChanged} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                                            {psychiatristOptions && psychiatristOptions.length < 1 && <option value=''>No active psychiatrist available</option>}
                                                            {psychiatristOptions && psychiatristOptions.length > 0 && <option value=''>Please select</option>}
                                                            {psychiatristOptions}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 no-padding ">
                                            <div className="aj-dropdown with-label"><label>Assign Therapist</label>
                                                <div className="source">
                                                    <div className="question-selection">
                                                        <select ref="therapist" onChange={this.selectionChanged} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                                            {therapistOptions && therapistOptions.length < 1 && <option value=''>No active therapist available</option>}
                                                            {therapistOptions && therapistOptions.length > 0 && <option value=''>Please select</option>}
                                                            {therapistOptions}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                {this.state.errorMessage && <span className="red-color">{this.state.errorMessage}</span>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 no-padding recovery-buttons">
                                <button className="gray-button" onClick={this.add_facility_admin}>Send Invite</button>
                                <button className="white-button" onClick={this.cancel} >Back</button>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.okModalMessage && <ModalDialogCommon message={this.state.okModalMessage} action={this.closebox} />}
            </div>

        );
    }
});


let mapStateToProps = (state) => {
    return {
        PatientsDetails: state.Patients,
        UserDetails: state.User,
        FacilitiesDetails: state.Facilites

    };
};

let mapDispatchToProps = (dispatch) => ({
    PatientsActions: bindActionCreators(PatientsActions, dispatch),
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(AddPatients));



/** WEBPACK FOOTER **
 ** ./src/components/admin/patients/add-patients.js
 **/